const translations = {
    apiError: 'Something went wrong. Please try again.',
    flightControllerSerialConflict:
        'A drone already exists with this flight controller serial number.',
    title: 'Add Aircraft'
};

export default translations;
